// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logobar, .logobar__bg {
    max-width: 33vw;
    width: var(--logobar-width);
    transition: width 0.25s cubic-bezier(0.25, 0.25, 0.25, 1);
  }
  
  .logobar__bg {
    top: 0;
    height: 100vh;
    position: absolute;
    z-index: var(--z-index-sidebar-bg);
    background-color: #fff/*var(--button-bg);
    /* background-color: transparent !important; */
  }
  
  .logobar.hidden, .logobar__bg.hidden {
    width: 0;
  }
    
  /* INSIDE THE SIDEBAR */  
  .logobar {
    height: 100%;
    animation: overflow 0.25s;
  }
  .logobar.hidden > .logobar__content {
    transform: translateX(-280px);
  }
  
  .logobar__content {
    display: flex;
    overflow: hidden auto;
    flex-direction: column;
  
    height: 100%;
    max-width: 33vw;
    width: var(--logobar-width);
    transition: transform 0.25s;

    padding: 10px 10px 90px 10px;
  }
  
  .logobar hr {
    margin: 10px;
  }
  .logobar hr:first-child {
    margin-top: 0;
  }
   
  
  /* Fix for firefox showing scrollbar when hiding the sidebar */
  @keyframes overflow {
    0% { overflow: hidden; }
    100% { overflow: auto; }
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Auth/logoBar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,2BAA2B;IAC3B,yDAAyD;EAC3D;;EAEA;IACE,MAAM;IACN,aAAa;IACb,kBAAkB;IAClB,kCAAkC;IAClC,qBAAqB,CAAC;kDACwB;EAChD;;EAEA;IACE,QAAQ;EACV;;EAEA,uBAAuB;EACvB;IACE,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,sBAAsB;;IAEtB,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,2BAA2B;;IAE3B,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;;;EAGA,8DAA8D;EAC9D;IACE,KAAK,gBAAgB,EAAE;IACvB,OAAO,cAAc,EAAE;EACzB","sourcesContent":[".logobar, .logobar__bg {\r\n    max-width: 33vw;\r\n    width: var(--logobar-width);\r\n    transition: width 0.25s cubic-bezier(0.25, 0.25, 0.25, 1);\r\n  }\r\n  \r\n  .logobar__bg {\r\n    top: 0;\r\n    height: 100vh;\r\n    position: absolute;\r\n    z-index: var(--z-index-sidebar-bg);\r\n    background-color: #fff/*var(--button-bg);\r\n    /* background-color: transparent !important; */\r\n  }\r\n  \r\n  .logobar.hidden, .logobar__bg.hidden {\r\n    width: 0;\r\n  }\r\n    \r\n  /* INSIDE THE SIDEBAR */  \r\n  .logobar {\r\n    height: 100%;\r\n    animation: overflow 0.25s;\r\n  }\r\n  .logobar.hidden > .logobar__content {\r\n    transform: translateX(-280px);\r\n  }\r\n  \r\n  .logobar__content {\r\n    display: flex;\r\n    overflow: hidden auto;\r\n    flex-direction: column;\r\n  \r\n    height: 100%;\r\n    max-width: 33vw;\r\n    width: var(--logobar-width);\r\n    transition: transform 0.25s;\r\n\r\n    padding: 10px 10px 90px 10px;\r\n  }\r\n  \r\n  .logobar hr {\r\n    margin: 10px;\r\n  }\r\n  .logobar hr:first-child {\r\n    margin-top: 0;\r\n  }\r\n   \r\n  \r\n  /* Fix for firefox showing scrollbar when hiding the sidebar */\r\n  @keyframes overflow {\r\n    0% { overflow: hidden; }\r\n    100% { overflow: auto; }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
